import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27722 27721"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970271138416">
        <path
          d="M0 27721h6259l7602-7602 7602 7602h6259L13861 13861zM0 13861h6259l7602-7603 7602 7603h6259L13861 0z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
